import { render, staticRenderFns } from "./ComparisonBar.vue?vue&type=template&id=442e3c5e&scoped=true"
import script from "./ComparisonBar.vue?vue&type=script&lang=js"
export * from "./ComparisonBar.vue?vue&type=script&lang=js"
import style0 from "./ComparisonBar.vue?vue&type=style&index=0&id=442e3c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e3c5e",
  null
  
)

export default component.exports